<template>
  <div class="heim-toggle-button">
    <input :id="uid" type="checkbox" name="heim-toggle-button" class="heim-toggle-button-checkbox" :checked="value" @change="$emit('input', $event.target.checked)">
    <label class="heim-toggle-button-label" :for="uid"></label>
  </div>
</template>

<script>
export default {
  name: "heim-toggle-button",
  props: {
    uid: {
      type: String,
      default: "_uid"
    },
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.heim-toggle-button {
  position: relative;
  width: 37px;
  margin: 0.6em 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.heim-toggle-button-checkbox {
  display: none;
}
.heim-toggle-button-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  height: 14px;
  padding: 0;
  line-height: 14px;
  border: 0px solid #ffffff;
  border-radius: 30px;
  background-color: #9e9e9e;
}
.heim-toggle-button-label:before {
  content: "";
  display: block;
  width: 20px;
  height: 20px;
  margin: -3px;
  background: #ffffff;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 24px;
  border-radius: 30px;
  box-shadow: 0 6px 12px 0px #757575;
}
.heim-toggle-button-checkbox:checked + .heim-toggle-button-label {
  background-color: var(--heim-green-bgcolor);
}
.heim-toggle-button-checkbox:checked + .heim-toggle-button-label,
.heim-toggle-button-checkbox:checked + .heim-toggle-button-label:before {
  border-color: var(--heim-green-bgcolor);
}
.heim-toggle-button-checkbox:checked
  + .heim-toggle-button-label
  .heim-toggle-button-inner {
  margin-left: 0;
}
.heim-toggle-button-checkbox:checked + .heim-toggle-button-label:before {
  right: 0px;
  background-color: var(--heim-darkgreen-color);
  box-shadow: 3px 6px 18px 0px rgba(0, 0, 0, 0.2);
}
</style>
